var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CookieConsentInfo from "./CookieConsentInfo.vue";
import LanguageSelection from '@/common/components/LanguageSelection.vue';
import TermsOfUseService from "@/common/services/TermsOfUseService";
import { Notification } from "@/common/services/notificationService";
var TermsOfUseDialog = /** @class */ (function (_super) {
    __extends(TermsOfUseDialog, _super);
    function TermsOfUseDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lang = null;
        _this.termsTitle = null;
        _this.termsBody = null;
        _this.winHeight = '500px';
        _this.termsOfUse = null;
        _this.termsOfUseService = new TermsOfUseService();
        _this.termsReadEmitted = false;
        return _this;
    }
    TermsOfUseDialog.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.initializeTermsOfUse()];
                    case 1:
                        _a.termsOfUse = _b.sent();
                        this.lang = this.$i18n.locale;
                        this.selectText();
                        this.winHeight = this.calculateWinHeight();
                        window.addEventListener("resize", this.onWinChange);
                        return [2 /*return*/];
                }
            });
        });
    };
    TermsOfUseDialog.prototype.destroyed = function () {
        window.removeEventListener("resize", this.onWinChange);
    };
    TermsOfUseDialog.prototype.onChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.lang = this.$i18n.locale;
                this.selectText();
                return [2 /*return*/];
            });
        });
    };
    ;
    TermsOfUseDialog.prototype.calculateWinHeight = function () {
        return Math.max(100, Math.floor((window.innerHeight - 200) * 0.75)) + 'px';
    };
    TermsOfUseDialog.prototype.onWinChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newWinHeight;
            return __generator(this, function (_a) {
                newWinHeight = this.calculateWinHeight();
                if (newWinHeight != this.winHeight) {
                    this.winHeight = newWinHeight;
                }
                return [2 /*return*/];
            });
        });
    };
    ;
    TermsOfUseDialog.prototype.selectText = function () {
        if (this.termsOfUse) {
            this.termsTitle = this.lang == 'sv' ? this.termsOfUse.termsTitleSv : this.termsOfUse.termsTitleFi;
            this.termsBody = this.lang == 'sv' ? this.termsOfUse.termsBodySv : this.termsOfUse.termsBodyFi;
        }
    };
    Object.defineProperty(TermsOfUseDialog.prototype, "show", {
        get: function () {
            return this.allowShow && this.termsOfUse && !this.termsOfUse.alreadyApproved;
        },
        enumerable: false,
        configurable: true
    });
    TermsOfUseDialog.prototype.acceptTerms = function () {
        this.$emit('termsAccepted', true);
    };
    TermsOfUseDialog.prototype.rejectTerms = function () {
        this.$emit('termsAccepted', false);
    };
    TermsOfUseDialog.prototype.setRead = function () {
        this.$emit('termsRead', true);
        this.termsReadEmitted = true;
    };
    TermsOfUseDialog.prototype.onHide = function () {
        if (!this.loggedIn) {
            this.$emit('termsRead', this.termsReadEmitted); // if terms are once read they are read
        }
    };
    TermsOfUseDialog.prototype.initializeTermsOfUse = function () {
        return __awaiter(this, void 0, Promise, function () {
            var terms;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loggedIn) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.termsOfUseService.getTermsOfUseByUser()];
                    case 1:
                        terms = _a.sent();
                        if (terms.alreadyApproved)
                            this.$emit('alreadyApproved', true); // User has already approved terms
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.termsOfUseService.getTermsOfUse()];
                    case 3:
                        terms = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (terms == null)
                            Notification.error(this, this.$t("TermsOfUse.TermsOfUseNotFound"));
                        return [2 /*return*/, terms];
                }
            });
        });
    };
    __decorate([
        Prop({ type: Boolean, required: false }),
        __metadata("design:type", Boolean)
    ], TermsOfUseDialog.prototype, "loggedIn", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], TermsOfUseDialog.prototype, "allowShow", void 0);
    __decorate([
        Watch("$i18n.locale"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TermsOfUseDialog.prototype, "onChange", null);
    TermsOfUseDialog = __decorate([
        Component({
            name: "TermsOfUseDialog",
            components: {
                CookieConsentInfo: CookieConsentInfo,
                LanguageSelection: LanguageSelection
            }
        })
    ], TermsOfUseDialog);
    return TermsOfUseDialog;
}(Vue));
export default TermsOfUseDialog;
